export const ru = {
  common: {
    loading: 'Загрузка...',
    back: 'Назад',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    create: 'Создать',
    apply: 'Применить',
    confirm: 'Подтвердить',
    yes: 'Да',
    no: 'Нет',
    close: 'Закрыть',
    next: 'Далее',
    previous: 'Назад',
    skip: 'Пропустить',
    done: 'Готово',
    error: 'Ошибка',
    success: 'Успешно',
    saving: 'Сохранение...',
    deleting: 'Удаление...',
    optional: '(необязательно)',
    required: 'обязательно',
    chooseFile: 'Выбрать файл',
    nothingFound: 'Ничего не найдено',
    untitled: 'Без названия',
    description: 'Описание',
    title: 'Название',
    name: 'Имя',
    date: 'Дата',
    actions: 'Действия',
    all: 'Все',
    status: 'Статус',
    category: 'Категория',
    amount: 'Сумма',
    filters: 'Фильтры',
    search: 'Поиск',
    selected: 'Выбрано',
    currency: 'Валюта',
  },
  errors: {
    generic: 'Произошла ошибка. Попробуйте позже.',
    authTitle: 'Ошибка авторизации',
    devMode: 'Режим разработки',
    devModeHint: 'Откройте приложение через Telegram для полной функциональности',
    notFound: 'Не найдено',
    forbidden: 'Доступ запрещён',
    loadTitle: 'Не получается загрузить',
    loadHint: 'Проверьте интернет и попробуйте ещё раз.',
    reload: 'Обновить',
    networkError: 'Ошибка сети',
  },
  language: {
    label: 'Язык',
    ru: 'Русский',
    en: 'English',
    kk: 'Қазақша',
  },
  announcement: {
    eyebrow: 'Что нового',
    next: 'Далее',
    gotIt: 'Понятно',
  },
  tabs: {
    collections: 'Подборки',
    dashboard: 'Главная',
    expenses: 'Расходы',
    materials: 'Материалы',
    stages: 'Этапы',
    profile: 'Профиль',
  },
  login: {
    title: 'Войти в etap',
    subtitle: 'Войдите, чтобы продолжить работу с ремонтом',
    telegramBtn: 'Войти через Telegram',
    telegramSigningIn: 'Входим…',
    telegramConfirm: 'Подтвердите вход в окне Telegram. Если оно не открылось, разрешите всплывающие окна и повторите попытку.',
    telegramUnavailable: 'Не удалось загрузить Telegram. Проверьте соединение и попробуйте ещё раз.',
    telegramFailed: 'Не удалось войти через Telegram. Попробуйте ещё раз.',
    telegramExpired: 'Сессия входа обновлена. Нажмите кнопку ещё раз.',
    retry: 'Попробовать ещё раз',
    cancel: 'Отмена',
    yandexBtn: 'Войти через Яндекс',
    or: 'или',
    benefits: 'Безопасный вход · Пароль не нужен',
    miniAppHint: 'Или пользуйтесь прямо в Telegram —',
    miniAppLink: 'открыть Mini App',
  },
  legal: {
    loginNotice: 'Входя, вы принимаете',
    loginTerms: 'Условия использования',
    loginConsentPrefix: 'и даёте',
    loginConsent: 'согласие на обработку персональных данных',
    loginPolicyPrefix: 'в соответствии с',
    loginPolicy: 'Политикой конфиденциальности',
    documents: 'Документы',
    privacy: 'Политика конфиденциальности',
    terms: 'Условия использования',
    consent: 'Согласие на обработку данных',
    cookieText: 'Мы используем cookie и Яндекс Метрику, чтобы сервис работал и становился удобнее. Продолжая, вы соглашаетесь с',
    cookieLink: 'обработкой данных',
    cookieOk: 'Понятно',
  },
  onboarding: {
    step1Title: 'Добро пожаловать в etap',
    step1Desc: 'Контроль ремонта и бюджета в одном месте.',
    step2Title: 'Создайте проект',
    step2Desc: 'Дайте проекту название и установите бюджет.',
    step3Title: 'Пригласите команду',
    step3Desc: 'До 5 человек — партнёры, родственники, подрядчики.',
    step4Title: 'Готово!',
    step4Desc: 'Управляйте расходами и этапами вместе с командой.',
    skip: 'Пропустить',
    start: 'Начать',
    budgetOptionalHint: 'Необязательно — можно добавить позже',
  },
  stories: {
    report: {
      title: 'Новый отчёт',
      desc: 'Готов свежий отчёт по проекту',
      cta: 'Открыть отчёт',
    },
    poll: {
      thanks: 'Спасибо за ответ',
      thanksSub: 'Ваше мнение учтено и поможет нам сделать продукт лучше.',
      step: 'Вопрос {{current}} из {{total}}',
    },
    renovation: {
      day: {
        circle: 'День ремонта',
        slideTitle: 'Сегодня {{day}}-й день ремонта',
        slideSub: 'Отслеживайте прогресс и держите ремонт под контролем.',
      },
      expenses: {
        title: 'Расходы',
        desc: 'Фиксируй стоимость работ и материалов — смотри сколько ушло за месяц и весь ремонт',
      },
      stages: {
        title: 'Этапы',
        desc: 'Планируй ремонт по шагам с чеклистами — отслеживай прогресс в реальном времени',
      },
      materials: {
        title: 'Закупки',
        desc: 'Составляй список материалов, фиксируй цены и статусы',
      },
      ai: {
        title: 'AI-анализ',
        desc: 'AI изучит твою смету и даст советы — доступно после нескольких записей',
      },
      team: {
        title: 'Команда',
        desc: 'Пригласи партнёра или подрядчика по ссылке — до 5 человек на проект',
      },
    },
    finance: {
      expenses: {
        title: 'Расходы',
        desc: 'Записывай траты по категориям и смотри аналитику за любой период',
      },
      analytics: {
        title: 'Аналитика',
        desc: 'Графики и разбивка расходов по категориям — всегда видно куда уходят деньги',
      },
      multicurrency: {
        title: 'Мультивалюта',
        desc: 'Рубли, доллары, евро и крипто — все расходы в одном проекте',
      },
      ai: {
        title: 'AI-советник',
        desc: 'Умный анализ расходов: покажет аномалии, тренды и куда утекает бюджет',
      },
      report: {
        title: 'Отчёт',
        desc: 'Еженедельная сводка по расходам прямо в Telegram',
      },
    },
  },
  profile: {
    title: 'Профиль',
    settings: 'Настройки',
    logout: 'Выйти',
    logoutAll: 'Выйти со всех устройств',
    language: 'Язык интерфейса',
    defaultCurrency: 'Валюта по умолчанию',
    weeklyReport: 'Еженедельный отчёт',
    weeklyReportDesc: 'Получайте сводку по проекту в Telegram',
    sendNow: 'Отправить сейчас',
    sendOk: 'Отчёт отправлен в Telegram',
    sendInProgress: 'Отправляем...',
    sendCooldown: 'Можно отправить раз в сутки',
    selectProject: 'Выберите проект для отчёта',
    enableReport: 'Включить отчёт',
    dayLabel: 'День недели',
    days: {
      0: 'Воскресенье',
      1: 'Понедельник',
      2: 'Вторник',
      3: 'Среда',
      4: 'Четверг',
      5: 'Пятница',
      6: 'Суббота',
    },
    timeZone: 'Часовой пояс',
    timeZoneAuto: 'Определяется автоматически: {{tz}}',
    saving: 'Сохраняем...',
    saved: 'Сохранено',
    confirmLogout: 'Выйти из аккаунта?',
    confirmLogoutAll: 'Выйти со всех устройств?',
    support: 'Поддержка',
    feedback: 'Оставить отзыв',
    aboutApp: 'О приложении',
    versionLabel: 'Версия',
  },
  dashboard: {
    settingsTitle: 'Настройки главной',
    settingsHint: 'Выберите, что показывать первым и крупно. Остальные блоки можно скрыть — глазком справа.',
    settingsMainBadge: 'главный',
    settingsShow: 'Показывать',
    settingsHide: 'Скрыть',
    blockFinance: 'Бюджет',
    blockFinanceDesc: 'Потрачено, остаток, планируемые траты',
    blockStages: 'Этапы',
    blockStagesDesc: 'Текущий этап и прогресс работ',
    blockPlans: 'Планировка',
    blockPlansDesc: 'Чертёж квартиры, площадь и комнаты',
    blockMaterials: 'Материалы',
    blockMaterialsDesc: 'Подборки товаров, из которых выбираете',
    blockReports: 'AI-отчёты',
    blockReportsDesc: 'Еженедельный разбор расходов',
    plansHeroEmpty: 'Нарисуйте планировку квартиры — площадь комнат посчитается сама.',
    plansHeroOpen: 'Открыть планировщик',
    plansHeroCount_one: 'ещё {{count}}',
    plansHeroCount_few: 'ещё {{count}}',
    plansHeroCount_many: 'ещё {{count}}',
    plansHeroCount_other: 'ещё {{count}}',
    title: 'Главная',
    chooseProject: 'Выберите проект',
    chooseProjectHint: 'Создайте свой первый проект, чтобы начать',
    newProject: 'Новый проект',
    selectProjectLabel: 'Активный проект',
    activeProject: 'Активный проект',
    switchProject: 'Сменить проект',
    settings: 'Настройки проекта',
    inviteMembers: 'Пригласить участников',
    budgetTotal: 'Бюджет',
    spent: 'Потрачено',
    remaining: 'Осталось',
    overspent: 'Перерасход',
    progress: 'Прогресс',
    quickActions: 'Быстрые действия',
    actionAddExpense: 'Добавить расход',
    actionOpenStages: 'Этапы',
    actionOpenMaterials: 'Подборки товаров',
    actionOpenKanban: 'Канбан',
    recentExpenses: 'Последние расходы',
    seeAll: 'Все →',
    noExpenses: 'Пока нет расходов',
    addFirstExpense: 'Добавьте первый расход',
    stagesProgress: 'Прогресс этапов',
    noStages: 'Этапы ещё не созданы',
    upcomingPlanned: 'Ждут оплаты',
    of: 'из',
    projectsCount_one: '{{count}} проект',
    projectsCount_few: '{{count}} проекта',
    projectsCount_many: '{{count}} проектов',
    projectsCount_other: '{{count}} проекта',
    myProjects: 'Мои проекты',
    roleEditor: 'Редактор',
    roleViewer: 'Наблюдатель',
    membersWithCount: 'Участники ({{count}}/{{limit}})',
    editProject: 'Редактировать проект',
    deleteCurrentProject: 'Удалить текущий проект',
    deletingProject: 'Удаление...',
    leavingProject: 'Выходим...',
    leaveProject: 'Выйти из проекта',
    deleteOnlyProjectConfirm: 'Вы уверены что хотите удалить проект? Это единственный проект, все данные будут потеряны.',
    deleteProjectConfirm: 'Удалить проект "{{title}}"? Все расходы и данные проекта будут удалены.',
    leaveProjectConfirm: 'Выйти из проекта "{{title}}"?',
    monthSpent: 'за месяц',
    draftsCount_one: '{{count}} расход',
    draftsCount_few: '{{count}} расхода',
    draftsCount_many: '{{count}} расходов',
    draftsCount_other: '{{count}} расхода',
    draftsOverRemaining: 'больше, чем осталось',
    // Короткий вариант «Планируемых трат» для узкой KPI-плитки.
    plannedShort: 'Планируется',
    periodSpend: 'Траты за период',
    nextStage: 'Далее',
    quickRepairDay: 'День рем.',
    quickAi: 'Отчеты AI',
    progressUsed: '{{percent}}% освоено',
    aiGateTitle: 'Прораб AI — анализ расходов',
    aiGateTitleFinance: 'AI-советник — анализ финансов',
    aiGateDesc: 'Для точного анализа заполните данные о проекте и внесите первые расходы.',
    aiGateDescFinance: 'Внесите первые расходы чтобы AI начал анализировать ваши финансы.',
    areaRequired: 'Площадь квартиры',
    notSpecified: 'Не указана',
    specify: 'Указать',
    minExpenses: 'Минимум 3 расхода',
    expensesEntered: '{{count}} из {{required}} внесено',
    aiObservation_one: '{{count}} наблюдение',
    aiObservation_few: '{{count}} наблюдения',
    aiObservation_many: '{{count}} наблюдений',
    aiObservation_other: '{{count}} наблюдения',
    aiLabelInfo: 'Наблюдение',
    aiLabelWarning: 'Внимание',
    aiLabelAlert: 'Важно',
    aiLabelTip: 'Совет',
    aiNoObservations: 'Пока нет наблюдений',
    aiRefreshAvailable: 'Обновление доступно',
    aiNextReport: 'Следующий отчёт через {{time}}',
    details: 'Детализация',
    spentAllTime: 'Всего потрачено',
    allTime: 'за всё время',
    currentPeriod: 'текущий период',
    next14Days: 'следующие 14 дней',
    pricePerSqm: 'Цена за м²',
    createStagesHint: 'Создайте этапы для отслеживания прогресса',
    start: 'Начать →',
    products: 'Подборки',
    shoppingList: 'Подборки товаров',
    itemsCount: 'позиций: {{count}}',
    planPurchases: 'Планируйте покупки',
    collectionsPitch: 'Выбираете смеситель или плитку?',
    collectionsPitchSub: 'Сохраняйте варианты из магазинов и сравнивайте цены',
    newBadge: 'Новое',
    weeklyReports: 'Еженедельные отчеты',
    weeklyReportForProject: 'Отчет по проекту "{{title}}" каждый {{day}} в 10:00',
    weeklyReportGeneric: 'Отчет в Telegram каждый {{day}} в 10:00',
    reportDayAria: 'День недели для отчёта',
    sendingReport: 'Отправка...',
    nextReportAt: 'Следующий отчет {{time}}',
    sendReportNow: 'Отправить отчет сейчас',
    noProjectsForReport: 'У вас пока нет проектов для отчета',
    reportSent: 'Отчет отправлен в Telegram',
    reportSendError: 'Не удалось отправить отчет',
    supportQuestion: 'Возникли проблемы?',
    contactSupport: 'Обратиться в поддержку',
    viewAnnouncements: 'Все анонсы',
    weekdaysShort: {
      0: 'Вс',
      1: 'Пн',
      2: 'Вт',
      3: 'Ср',
      4: 'Чт',
      5: 'Пт',
      6: 'Сб',
    },
    weekdaysReport: {
      0: 'воскресенье',
      1: 'понедельник',
      2: 'вторник',
      3: 'среду',
      4: 'четверг',
      5: 'пятницу',
      6: 'субботу',
    },
    period: {
      day: 'день',
      week: 'неделя',
      month: 'месяц',
      year: 'год',
      all: 'всё время',
    },
  },
  expenses: {
    reportPromoTitle: 'Отчёт раз в неделю',
    reportPromoText: 'Вы уже записали {{total}}. Раз в неделю пришлю разбор — читать ничего не нужно, он приходит сам.',
    reportPromoPoint1: 'Сколько ушло за неделю и на какие категории',
    reportPromoPoint2: 'Где вы вышли за лимит и какие счета просрочены',
    reportPromoPoint3: 'На сколько недель хватит остатка бюджета',
    reportPromoAction: 'Включить отчёт',
    title: 'Расходы',
    add: 'Добавить расход',
    edit: 'Редактировать расход',
    delete: 'Удалить расход',
    deleteConfirm: 'Удалить этот расход?',
    splitConfirm: 'Разделить расход?',
    splitTitle: 'Разделить расход',
    splitDesc: 'Часть суммы оплачена сейчас, остаток — позже',
    splitPaidAmount: 'Оплачено сейчас',
    splitRemaining: 'Останется',
    splitBtn: 'Разделить',
    noExpenses: 'Пока нет расходов',
    noExpensesHint: 'Добавьте первый расход, чтобы начать учёт бюджета',
    total: 'Всего',
    monthTotal: 'За месяц',
    weekTotal: 'За неделю',
    filterStatus: 'Статус',
    filterCategory: 'Категория',
    filterPayee: 'Тип получателя',
    filterMethod: 'Способ оплаты',
    filterDateFrom: 'Дата от',
    filterDateTo: 'Дата до',
    resetFilters: 'Сбросить фильтры',
    statusDraft: 'Планируется',
    statusPending: 'Ждёт оплаты',
    statusPaid: 'Оплачен',
    statusCancelled: 'Отменён',
    payeeContractor: 'Подрядчик',
    payeeOther: 'Другое',
    methodCash: 'Наличные',
    methodCard: 'Карта',
    methodTransfer: 'Перевод',
    methodInvoice: 'Счёт',
    methodOther: 'Другое',
    amount: 'Сумма',
    amountPlaceholder: 'Введите сумму',
    descriptionPlaceholder: 'Что купили или за что заплатили',
    contractorLabel: 'Подрядчик',
    contractorPlaceholder: 'Выберите или введите имя',
    storeLabel: 'Магазин',
    storePlaceholder: 'Название магазина',
    tagsLabel: 'Теги',
    chartTagSuggestions: 'Фильтр по тегам',
    chartTagSuggestionsHint: 'Покажите расходы с нужной меткой',
    filterByTag: 'Фильтровать по тегу {{tag}}',
    clearTagFilter: 'Снять фильтр по тегу {{tag}}',
    tagsPlaceholder: 'Например: прораб-алексей, леруа-мерлен',
    receipt: 'Чек / фото',
    uploadReceipt: 'Прикрепить фото',
    paymentDate: 'Дата оплаты',
    deleteReceipt: 'Удалить фото',
    chartCategory: 'По категориям',
    chartStatus: 'По статусам',
    aiNoSuggestions: 'Нет подсказок — добавьте больше расходов',
    aiSuggest: 'Подсказать категорию',
    receivedFrom: 'Получатель',
    chartLabel: 'Сводка',
    showChart: 'Показать график',
    hideChart: 'Скрыть график',
    perCategory: 'По категориям',
    groupByMonth: 'По месяцам',
    groupByWeek: 'По неделям',
    groupByDay: 'По дням',
    overspentWarning: 'Превышение лимита по категории',
    copyExpense: 'Дублировать',
    filters: 'Фильтры',
    allCategories: 'Все категории',
    subcategory: 'Подкатегория',
    payeeBuilders: 'Строители',
    payeeDesigner: 'Дизайнер',
    payeeLawyers: 'Юристы',
    payeeStore: 'Магазин',
    paid: 'Оплачено',
    tabPaid: 'Оплаченные',
    tabPlanned: 'Планируемые',
    drafts: 'Планируемые траты',
    spend: 'Траты',
    aiAnalyzingProject: 'Прораб AI анализирует проект...',
    retry: 'Повторить',
    aiNoNewIdeas: 'Прораб AI не нашёл новых идей — кажется, у вас уже всё учтено!',
    noExpensesFiltered: 'Нет расходов по выбранным фильтрам',
    noPlannedExpenses: 'Нет планируемых трат',
    addFirst: 'Добавить первый расход',
    draftsPlanned: 'Планируемые траты',
    hideList: 'Скрыть список',
    showList: 'Показать ({{count}})',
    unnamed: 'Без названия',
    advance: 'Часть оплаты',
    filterPartlyPaid: 'С частичной оплатой',
    plannedTotal: 'Запланировано',
    selectMode: 'Выбрать',
    selectDone: 'Готово',
    selectAll: 'Выбрать все',
    selectNone: 'Снять выбор',
    selectHint: 'Отметьте траты — посчитаем сумму',
    selectedCount: 'Выбрано {{count}} из {{total}}',
    fullPrice: 'Полная стоимость',
    paidByAdvance: 'Оплачено',
    remainder: 'Остаток',
    paymentProgress: 'Оплата расхода',
    advanceAmountLabel: 'Сумма платежа',
    editAdvance: 'Редактировать часть оплаты',
    remainderHint: 'Оплачено {{paid}} · остаток {{remainder}}',
    fullPriceBelowAdvances: 'Полная стоимость должна быть больше уже оплаченной части',
    advancePaid: 'оплачено {{paid}} из {{total}}',
    pay: 'Оплатить',
    paidPart: 'часть оплаты',
    toTop: 'Наверх',
    payAdvance: 'Внести часть оплаты',
    advanceHint: 'Указанная часть станет оплаченной, остаток суммы останется в планах.',
    advanceAmount: 'Сумма платежа, ₽',
    createCopy: 'Создать копию',
    copiedTitle: 'Копия расхода',
    newTitle: 'Новый расход',
    basicInfo: 'Основная информация',
    expenseName: 'Название расхода',
    expenseNamePlaceholder: 'Например: Первый платёж за плитку',
    note: 'Примечание',
    notePlaceholder: 'Например: за какие работы или детали оплаты',
    paymentDetails: 'Детали оплаты',
    paidTo: 'Кому оплатили',
    draftToggle: 'Это планируемая трата',
    draftHint: 'Пока не оплачено и может измениться. Такая трата попадёт в планы, но не в потраченное. Когда внесёте часть суммы — отметьте её как часть оплаты, остаток останется в планах.',
    extra: 'Дополнительно',
    tagsFilterTitle: 'Настройте фильтры под себя',
    tagsFilterDescription: 'Добавляйте свои метки, чтобы точнее фильтровать расходы — например, по имени прораба или названию магазина.',
    tagsUsedLabel: 'Ранее использованные',
    tagsHint: 'Разделяйте теги запятой или пробелом',
    paymentHistory: 'История платежей',
    remainingDraft: 'Остаток в планах',
    mainPayment: 'Основной платёж',
    linkedExpense: 'Связанный расход',
    invalidAmount: 'Введите корректную сумму',
    nameRequired: 'Введите название расхода',
    saveError: 'Ошибка сохранения',
    loadError: 'Не удалось загрузить расход',
    deleteError: 'Не удалось удалить',
    uncategorized: 'Без категории',
    noSubcategory: 'Без подкатегории',
    categories: {
      'Стройматериалы': 'Стройматериалы',
      'Работы': 'Работы',
      'Техника и оборудование': 'Техника и оборудование',
      'Услуги': 'Услуги',
      'Прочее': 'Прочее',
      'Еда и продукты': 'Еда и продукты',
      'Транспорт': 'Транспорт',
      'Жильё и ЖКУ': 'Жильё и ЖКУ',
      'Здоровье': 'Здоровье',
      'Развлечения': 'Развлечения',
      'Одежда и уход': 'Одежда и уход',
      'Образование': 'Образование',
      'Техника и гаджеты': 'Техника и гаджеты',
      'Маркетплейсы': 'Маркетплейсы',
      'Путешествия': 'Путешествия',
      'Кофе': 'Кофе',
    },
    subcategories: {
      'Материалы': 'Материалы',
      'Черновые материалы': 'Черновые материалы',
      'Отделка': 'Отделка',
      'Плитка': 'Плитка',
      'Полы': 'Полы',
      'Потолки': 'Потолки',
      'Окна и двери': 'Окна и двери',
      'Краска': 'Краска',
      'Обои': 'Обои',
      'Сухие смеси и штукатурка': 'Сухие смеси и штукатурка',
      'Гипсокартон и профиль': 'Гипсокартон и профиль',
      'Изоляция и гидроизоляция': 'Изоляция и гидроизоляция',
      'Крепёж и расходники': 'Крепёж и расходники',
      'Кабель и электроматериалы': 'Кабель и электроматериалы',
      'Трубы и фитинги': 'Трубы и фитинги',
      'Плинтусы и молдинги': 'Плинтусы и молдинги',
      'Электромонтаж': 'Электромонтаж',
      'Сантехмонтаж': 'Сантехмонтаж',
      'Плиточные работы': 'Плиточные работы',
      'Малярные работы': 'Малярные работы',
      'Потолочные работы': 'Потолочные работы',
      'Напольные работы': 'Напольные работы',
      'Установка окон и дверей': 'Установка окон и дверей',
      'Сборка и установка мебели': 'Сборка и установка мебели',
      'Бытовая техника': 'Бытовая техника',
      'Кухонная техника': 'Кухонная техника',
      'Умный дом и слаботочка': 'Умный дом и слаботочка',
      'Дизайн-проект': 'Дизайн-проект',
      'Замеры': 'Замеры',
      'Аренда инструмента и техники': 'Аренда инструмента и техники',
      'Вывоз мусора': 'Вывоз мусора',
      'Клининг после ремонта': 'Клининг после ремонта',
      'Грузчики и подъём': 'Грузчики и подъём',
      'Технадзор': 'Технадзор',
      'Резерв на непредвиденное': 'Резерв на непредвиденное',
      'Коммунальные платежи': 'Коммунальные платежи',
      'Аренда жилья на время ремонта': 'Аренда жилья на время ремонта',
      'Демонтаж': 'Демонтаж',
      'Черновые работы': 'Черновые работы',
      'Отделочные работы': 'Отделочные работы',
      'Монтажные работы': 'Монтажные работы',
      'Сантехника': 'Сантехника',
      'Электрика': 'Электрика',
      'Вентиляция': 'Вентиляция',
      'Отопление': 'Отопление',
      'Освещение': 'Освещение',
      'Мебель': 'Мебель',
      'Техника': 'Техника',
      'Кондиционеры': 'Кондиционеры',
      'Доставка': 'Доставка',
      'Проектирование': 'Проектирование',
      'Разрешения': 'Разрешения',
      'Консультации': 'Консультации',
      'Инструменты': 'Инструменты',
      'Декор': 'Декор',
      'Прочее': 'Прочее',
      'Продукты': 'Продукты',
      'Рестораны и кафе': 'Рестораны и кафе',
      'Доставка еды': 'Доставка еды',
      'Топливо': 'Топливо',
      'Общественный транспорт': 'Общественный транспорт',
      'Такси': 'Такси',
      'Обслуживание авто': 'Обслуживание авто',
      'Парковка': 'Парковка',
      'Аренда': 'Аренда',
      'Ипотека': 'Ипотека',
      'Коммунальные услуги': 'Коммунальные услуги',
      'Интернет и связь': 'Интернет и связь',
      'Ремонт и обслуживание': 'Ремонт и обслуживание',
      'Врачи и клиники': 'Врачи и клиники',
      'Лекарства': 'Лекарства',
      'Спорт и фитнес': 'Спорт и фитнес',
      'Страховка': 'Страховка',
      'Подписки': 'Подписки',
      'Кино и театр': 'Кино и театр',
      'Путешествия': 'Путешествия',
      'Хобби': 'Хобби',
      'Игры': 'Игры',
      'Одежда и обувь': 'Одежда и обувь',
      'Уход за собой': 'Уход за собой',
      'Курсы и обучение': 'Курсы и обучение',
      'Книги': 'Книги',
      'Детское образование': 'Детское образование',
      'Подарки': 'Подарки',
      'Благотворительность': 'Благотворительность',
      'Смартфон': 'Смартфон',
      'Ноутбук': 'Ноутбук',
      'Планшет': 'Планшет',
      'Наушники': 'Наушники',
      'Аксессуары': 'Аксессуары',
      'Ozon': 'Ozon',
      'Wildberries': 'Wildberries',
      'Яндекс.Маркет': 'Яндекс.Маркет',
      'Билеты': 'Билеты',
      'Жильё': 'Жильё',
      'Трансфер': 'Трансфер',
      'Кофейня': 'Кофейня',
      'Кофе навынос': 'Кофе навынос',
    },
  },
  stages: {
    title: 'Этапы',
    add: 'Новый этап',
    addItem: 'Новый пункт',
    delete: 'Удалить этап',
    deleteConfirm: 'Удалить этот этап?',
    deleteWithItemsConfirm: 'Удалить этап? Все задачи этапа также будут удалены.',
    deleteItemConfirm: 'Удалить этот пункт?',
    notFound: 'Этап не найден',
    noStages: 'Этапов пока нет',
    noStagesHint: 'Создайте этапы вручную или примените готовый шаблон',
    fromTemplate: 'Из шаблона',
    titleLabel: 'Название этапа',
    titlePlaceholder: 'Например: Электрика',
    descriptionLabel: 'Описание',
    descriptionPlaceholder: 'Что входит в этот этап',
    responsibleLabel: 'Ответственный',
    responsiblePlaceholder: 'Подрядчик или член команды',
    deadlineLabel: 'Дедлайн',
    progressLabel: 'Прогресс',
    statusNotStarted: 'Не начат',
    statusInProgress: 'В работе',
    statusCompleted: 'Завершён',
    statusBlocked: 'Заблокирован',
    showCompleted: 'Показать завершённые',
    hideCompleted: 'Скрыть завершённые',
    items: 'Пункты',
    noItems: 'Пунктов пока нет',
    itemTitleLabel: 'Что нужно сделать',
    itemTitlePlaceholder: 'Описание пункта',
    addItemPlaceholder: 'Добавить задачу...',
    itemDone: 'Выполнено',
    changeStatus: 'Сменить статус',
    templates: 'Шаблоны этапов',
    templateApply: 'Применить шаблон',
    selectAll: 'Выбрать все',
    deselectAll: 'Снять выбор',
    applyingTemplate: 'Применяем...',
  },
  kanban: {
    title: 'Канбан',
    columnTodo: 'К выполнению',
    columnDoing: 'В работе',
    columnDone: 'Готово',
    columnBlocked: 'Заблокировано',
    empty: 'Пусто',
    move: 'Перенести',
  },
  needCategories: {
    FLOORING: 'Напольные покрытия',
    TILES: 'Плитка',
    PLUMBING: 'Сантехника',
    LIGHTING: 'Освещение',
    ELECTRICAL: 'Электрика',
    DOORS: 'Двери',
    KITCHEN: 'Кухня и техника',
    WALLS_CEILING: 'Стены и потолок',
    WINDOWS_TEXTILE: 'Окна и текстиль',
    FURNITURE: 'Мебель',
    ELECTRONICS: 'Электроника',
    CLIMATE: 'Климат',
    SECURITY: 'Безопасность',
    STORAGE: 'Хранение',
    GARDEN: 'Сад и участок',
    CLEANING: 'Уборка',
    TOOLS: 'Инструменты',
    DECOR: 'Декор',
    TEXTILE: 'Текстиль',
    BATH: 'Ванная',
    OTHER: 'Прочее',
  },
  materials: {
    title: 'Материалы',
    add: 'Новый материал',
    delete: 'Удалить',
    deleteConfirm: 'Удалить материал?',
    noMaterials: 'Пока ничего не добавлено',
    noMaterialsHint: 'Соберите список покупок или примените шаблон',
    fromTemplate: 'Из шаблона',
    statusActive: 'В работе',
    statusBought: 'Куплено',
    statusCancelled: 'Отменено',
    nameLabel: 'Название',
    namePlaceholder: 'Например: Плитка для ванной',
    quantityLabel: 'Количество',
    unitLabel: 'Ед. изм.',
    categoryLabel: 'Категория',
    priorityLabel: 'Приоритет',
    priorityLow: 'Низкий',
    priorityMedium: 'Средний',
    priorityHigh: 'Высокий',
    notesLabel: 'Заметки',
    notesPlaceholder: 'Дополнительная информация',
    options: 'Варианты',
    addOption: 'Добавить вариант',
    optionTitle: 'Название',
    optionPrice: 'Цена',
    optionUrl: 'Ссылка',
    optionNotes: 'Комментарий',
    selectOption: 'Выбрать',
    deselectOption: 'Снять выбор',
    deleteOption: 'Удалить вариант',
    selected: 'Выбран',
    estimatedTotal: 'Ориентир по бюджету',
    boughtTotal: 'Куплено на сумму',
    templates: 'Шаблоны',
    applyTemplate: 'Применить шаблон',
    selectItems: 'Выберите пункты',
    itemCount_one: '{{count}} товар',
    itemCount_few: '{{count}} товара',
    itemCount_many: '{{count}} товаров',
    itemCount_other: '{{count}} товара',
    productCount_one: '{{count}} товар',
    productCount_few: '{{count}} товара',
    productCount_many: '{{count}} товаров',
    productCount_other: '{{count}} товара',
    deleteAllConfirm: 'Удалить все товары? Это действие нельзя отменить.',
    productsTitle: 'Товары',
    noProducts: 'Нет товаров',
    noProductsHint: 'Добавьте товары для планирования покупок',
    chooseTemplate: 'Выберите шаблон',
    selectedCount: 'Выбрано: {{selected}} из {{total}}',
    deselectAll: 'Снять все',
    applySelected: 'Применить {{count}} товаров',
    addOwnProduct: 'Или добавьте свой товар',
    searchPlaceholder: 'Поиск по названию...',
    nothingByFilters: 'Ничего не найдено по заданным фильтрам',
    optionsCount_one: '{{count}} вариант',
    optionsCount_few: '{{count}} варианта',
    optionsCount_many: '{{count}} вариантов',
    optionsCount_other: '{{count}} варианта',
    selectedLabel: 'Выбрано:',
    selectedOption: 'Выбранный вариант',
    price: 'Цена',
    edit: 'Редактировать',
    hideTemplates: 'Скрыть шаблоны',
    addMoreTemplate: 'Добавить ещё шаблон',
    resetAndChooseTemplate: 'Сбросить и выбрать шаблон',
    deleteProduct: 'Удалить товар',
    productNotFound: 'Товар не найден',
    openLink: 'Открыть ссылку →',
    optionTitlePlaceholder: 'Название (бренд, модель)',
    optionPricePlaceholder: 'Цена (опционально)',
    optionUrlPlaceholder: 'Ссылка на товар',
    linkHint: 'Вставьте ссылку на товар из любого магазина — название, цену и фото мы подставим сами.',
    pasteLink: 'Вставить',
    fillManually: 'Без ссылки — заполнить вручную',
    previewLoading: 'Читаю страницу товара…',
    previewFailed: 'Не удалось прочитать страницу — заполните вручную',
    previewEmpty: 'На странице не нашли данных о товаре — заполните вручную',
    previewFilled: 'Подставили: {{fields}} — проверьте и сохраните',
    previewForeignCurrency: 'Цена на странице в {{currency}}, а проект в {{project}} — введите цену сами',
    previewField: { title: 'название', price: 'цена', description: 'описание', image: 'фото' },
    optionDescriptionPlaceholder: 'Описание (опционально)',
    adding: 'Добавление...',
    deleteOptionConfirm: 'Удалить этот вариант?',
    optionsEmpty: 'Сохраняйте сюда товары, из которых выбираете: вставьте ссылку — название и цену подставим сами. Отметьте кружком тот, на котором остановились.',
    removeImage: 'Убрать фото',
    uploadImage: 'Загрузить фото',
    replaceImage: 'Заменить фото',
    imageUploading: 'Загружаем фото…',
    imageUploadFailed: 'Не удалось загрузить фото',
    dragToReorder: 'Перетащите, чтобы поменять порядок',
    reorderFailed: 'Не удалось сохранить порядок',
    compareView: 'Сравнить',
    listView: 'Списком',
    priceAboveCheapest: '+{{amount}} к самому дешёвому',
    compareNoPrice: 'Цена не указана',
    cheapest: 'Дешевле всех',
    deleteProductConfirm: 'Удалить товар? Все варианты также будут удалены.',
    collectionsTitle: 'Подборки',
    newCollection: 'Новая подборка',
    collectionNameLabel: 'Что подбираете?',
    collectionNamePlaceholder: 'Например: Смеситель на кухню',
    collectionsEmpty: 'Подборок пока нет',
    collectionsEmptyHint: 'Подборка — это товары, из которых вы выбираете: смесители, плитка, люстры. Вставьте ссылку из магазина — название, цену и фото подставим сами.',
    onboarding: {
      title: 'Выбирайте товары без хаоса',
      lead: 'Подборка — это варианты одной покупки из разных магазинов: смесители, плитка, люстры. Сохраните их в одном месте, сравните и купите, когда решите.',
      exampleTitle: 'Смеситель на кухню',
      exampleFrom: '3 товара · от 7 990 ₽',
      exampleItems: [
        { name: 'Lemark Comfort LM3061C', shop: 'santehnika-online.ru', price: '7 990 ₽' },
        { name: 'Grohe Eurosmart 33281003', shop: 'Wildberries', price: '12 990 ₽' },
        { name: 'Hansgrohe Focus M41', shop: 'Ozon', price: '15 400 ₽' },
      ],
      benefitLink: 'Вставьте ссылку из магазина — название, цену и фото подставим сами',
      benefitCompare: 'Сравните варианты рядом — сразу видно, кто дешевле и на сколько',
      benefitKeep: 'Ссылки не потеряются в чатах и вкладках — вернётесь к ним, когда будете покупать',
      startLabel: 'Что сейчас выбираете?',
      starters: ['Смеситель', 'Плитка в ванную', 'Ламинат', 'Люстра', 'Диван'],
      ownCollection: 'Своя подборка',
    },
    createCollection: 'Создать подборку',
    collectionNoItems: 'Пока пусто',
    collectionNotFound: 'Подборка не найдена',
    deleteCollection: 'Удалить подборку',
    deleteCollectionConfirm: 'Удалить подборку вместе со всеми товарами?',
    priceFrom: 'от {{price}}',
    addProduct: 'Добавить товар',
    buy: 'Купить',
    removeProduct: 'Удалить товар',
    removeProductConfirm: 'Удалить товар из подборки?',
    productsEmptyHint: 'Вставьте ссылку на товар — название, цену и фото подставим сами.',
    nothingFound: 'Ничего не найдено',
    note: 'Заметка',
  },
  projects: {
    mainBlockLabel: 'Что показывать на главной',
    mainBlockHint: 'Потом можно поменять в «Настройках главной»',
    newTitle: 'Новый проект',
    editTitle: 'Настройки проекта',
    deleteProject: 'Удалить проект',
    deleteConfirm: 'Удалить этот проект безвозвратно?',
    titleLabel: 'Название проекта',
    titlePlaceholder: 'Например: Квартира на набережной',
    typeRenovation: 'Ремонт',
    typeFinance: 'Финансы',
    financeDisclaimer: 'Это другой режим приложения — чистый трекинг финансов по жизни. Пока в режиме эксперимента.',
    budgetLabel: 'Бюджет',
    budgetPlaceholder: 'Сумма в рублях',
    currencyLabel: 'Валюта',
    currencyNoConversion: 'Смена валюты не пересчитывает уже созданные расходы, материалы и бюджетные строки.',
    areaLabel: 'Площадь (м²)',
    areaPlaceholder: 'Например: 60',
    startDateLabel: 'Дата начала ремонта',
    startDateHint: 'Используется для подсчёта текущего дня ремонта на главной.',
    creating: 'Создание...',
    saving: 'Сохранение...',
    leaveProject: 'Покинуть проект',
    leaveConfirm: 'Покинуть этот проект?',
  },
  members: {
    title: 'Участники',
    invite: 'Пригласить',
    inviteLink: 'Ссылка-приглашение',
    copy: 'Скопировать',
    copied: 'Скопировано!',
    expiresIn: 'Действует {{days}} дн.',
    revoke: 'Отозвать',
    role: 'Роль',
    roleOwner: 'Владелец',
    roleEditor: 'Редактор',
    roleViewer: 'Гость',
    you: 'вы',
    remove: 'Удалить',
    removeConfirm: 'Удалить участника?',
    limitReached: 'Достигнут лимит участников ({{limit}})',
    pendingInvites: 'Активные приглашения',
    activeMembers: 'Текущие участники',
    inviteAsRole: 'Пригласить как',
    expirationLabel: 'Срок действия',
    expirationOptions: {
      day: '1 день',
      week: '7 дней',
      month: '30 дней',
    },
    createInvite: 'Создать приглашение',
    inviteCreated: 'Приглашение создано',
  },
  accept: {
    title: 'Приглашение в проект',
    project: 'Проект',
    invitedBy: 'Пригласил',
    role: 'Ваша роль',
    accept: 'Принять приглашение',
    decline: 'Отказаться',
    accepting: 'Принимаем...',
    accepted: 'Вы приняли приглашение',
    expired: 'Приглашение истекло',
    invalid: 'Приглашение недействительно',
  },
  budget: {
    title: 'Бюджет-калькулятор',
    desc: 'Распределите общий бюджет по категориям и контролируйте лимиты',
    totalBudget: 'Общий бюджет',
    planned: 'Запланировано',
    leftToPlan: 'Осталось распределить',
    overPlanned: 'Перепланировано',
    distributeRemainder: 'Распределить остаток',
    distributing: 'Распределяем...',
    aiSuggest: 'Предложить AI',
    aiSuggesting: 'AI думает...',
    aiSuggestHint: 'AI распределит бюджет по типу проекта',
    aiPromptLabel: 'Опишите проект (необязательно)',
    aiPromptPlaceholder: 'Например: квартира 60 м², чистовая отделка',
    saving: 'Сохраняем...',
    plannedLabel: 'План',
    spentLabel: 'Потрачено',
    percentLabel: '% от бюджета',
    addCategory: 'Добавить категорию',
    deleteCategory: 'Удалить',
    categoryNamePlaceholder: 'Название категории',
    budgetReachedWarning: 'Сумма категорий превышает общий бюджет',
    calculatorTitle: 'Калькулятор бюджета',
    calculatorSubtitle: 'Распределите бюджет по категориям',
    aiDistribution: 'AI-распределение бюджета',
    aiAnalyzing: 'Анализирую...',
    availableIn: 'Доступно через {{time}}',
    distributeWithAi: '✨ Распределить с AI',
    planDistributed: 'Распределено по плану',
    planTotal: 'Итого по плану:',
    projectLimit: 'Лимит проекта:',
    limitRemaining: 'Остаток до лимита:',
    usage: 'Использование:',
    pricePerSqm: 'Цена за м²:',
    plannedExpenseItems: 'Плановые статьи расходов',
    autoDistributedHint: '💡 Бюджет автоматически распределен по рекомендованным категориям',
    deleteCategoryConfirm: 'Удалить категорию "{{category}}"?',
    addCategoryPrompt: 'Введите название категории',
    duplicateCategory: 'Категория с таким названием уже существует',
    categoryTooLong: 'Название категории слишком длинное (максимум 100 символов)',
    categoryInvalidChars: 'Название категории может содержать только буквы, цифры, пробелы, дефисы, скобки и слэш',
    loadPlanError: 'Ошибка загрузки плана',
    loadPlanFailed: 'Не удалось загрузить план',
    saveError: 'Ошибка сохранения',
    distributeError: 'Ошибка распределения',
    aiError: 'Ошибка запроса к AI',
    distributeRemainderAuto: 'Распределить остаток автоматически',
    categories: {
      'Ремонтные работы': 'Ремонтные работы',
      'Черновые материалы': 'Черновые материалы',
      'Чистовая отделка': 'Чистовая отделка',
      'Встроенная мебель': 'Встроенная мебель',
      'Отдельная мебель': 'Отдельная мебель',
      'Кухонная техника': 'Кухонная техника',
      'Бытовая техника и электроника': 'Бытовая техника и электроника',
      'Сантехника': 'Сантехника',
      'Инженерные системы': 'Инженерные системы',
      'Освещение': 'Освещение',
      'Текстиль и декор': 'Текстиль и декор',
      'Прочее / Резерв': 'Прочее / Резерв',
    },
  },
  support: {
    title: 'Поддержка',
    desc: 'Опишите проблему или поделитесь идеей. Мы ответим в Telegram-боте.',
    messageLabel: 'Сообщение',
    messagePlaceholder: 'Что случилось или что хочется улучшить?',
    contactLabel: 'Контакт (необязательно)',
    contactPlaceholder: 'Telegram, email или телефон',
    send: 'Отправить',
    sending: 'Отправляем...',
    sent: 'Спасибо! Сообщение отправлено.',
    error: 'Не удалось отправить. Попробуйте позже.',
    history: 'Ваши обращения',
    noRequests: 'Обращений пока нет',
    answered: 'Ответ',
  },
  reports: {
    title: 'Отчёты',
    cardSubtitle: 'Прошлые отчёты по проекту',
    markAllRead: 'Прочитать все',
    empty: 'Отчётов пока нет. Они появятся здесь после первой рассылки.',
    untitledProject: 'Проект',
    manual: 'Вручную',
  },
  files: {
    title: 'Файлы проекта',
    estimates: 'Сметы',
    photos: 'Фото',
    uploadEstimate: 'Загрузить смету',
    uploadPhoto: 'Добавить фото',
    empty: 'Пока нет ни одного фото.',
    emptyEstimates: 'Пока нет ни одной сметы. Загрузите PDF, Excel или скан от подрядчика.',
    download: 'Скачать',
    deleteConfirm: 'Удалить этот файл?',
    tooLarge: 'Файл слишком большой (максимум 15 МБ)',
    unsupportedType: 'Неподдерживаемый формат файла',
    quotaExceeded: 'Достигнут предел файлов для этого проекта',
    disabled: 'Загрузка файлов пока не настроена для этого проекта',
    parseToExpenses: 'Распознать в расходы',
    columnMapping: {
      description: 'Не удалось уверенно определить колонки — выберите их вручную.',
      descriptionColumn: 'Описание',
      amountColumn: 'Сумма',
      categoryColumn: 'Категория',
      confirm: 'Продолжить',
    },
    importReview: {
      selectAll: 'Выбрать все',
      import: 'Импортировать ({{count}})',
    },
    importResult: {
      summary: 'Импортировано {{success}} из {{total}}',
      errors: 'Пропущено: {{count}}',
    },
  },
  plans: {
    onboarding: {
      title: 'Планировка квартиры за пару минут',
      lead: 'Нарисуйте стены — комнаты, площади и расход отделки посчитаются сами. А потом посмотрите квартиру в 3D.',
      exampleRooms: {
        'room-1': 'Спальня',
        'room-2': 'Кухня-гостиная',
        'room-3': 'Спальня 2',
        'room-4': 'Санузел',
      },
      benefitDraw: 'Стены по сетке или по фото плана — замкнутый контур сам становится комнатой с площадью',
      benefitLayers: 'Мебель, розетки и сантехника — слоями, «Авто» расставит их по комнатам',
      benefitFinish: 'Отделка пола и стен: площадь стен без проёмов и длина плинтуса для сметы',
      benefit3d: 'Объёмный вид квартиры с мебелью и отделкой',
      heroAlt: 'Пример: двухкомнатная квартира с мебелью в 3D',
      startLabel: 'С чего начать',
      withFurniture: 'с мебелью',
      blank: 'С нуля',
      blankHint: 'Нарисовать свои стены или обвести фото',
      viewerHint: 'Владелец проекта ещё не добавил планировку.',
    },
    tour: {
      label: 'Как пользоваться планировщиком',
      open: 'Как пользоваться',
      skip: 'Закрыть подсказки',
      next: 'Дальше',
      back: 'Назад',
      done: 'Понятно',
      walls: {
        title: 'Рисуйте стены',
        text: 'Инструмент «Стена»: зажмите и протяните — получится стена. Тапы по углам рисуют стены цепочкой. Есть фото плана — загрузите его кнопкой с картинкой вверху, AI обведёт стены.',
      },
      rooms: {
        title: 'Комнаты появятся сами',
        text: 'Замкнутый контур стен становится комнатой с площадью. Тапните по комнате — там название, отделка пола и стен, площадь стен без проёмов и плинтус.',
      },
      layers: {
        title: 'Мебель и инженерка',
        text: 'Переключите слой: мебель, электрика, сантехника. Предметы — из каталога, а «Авто» расставит их по комнатам сам.',
      },
      '3d': {
        title: 'Посмотрите в 3D',
        text: 'Квартира целиком, с мебелью и отделкой. Вращайте пальцем, ножницы срезают ближние стены.',
      },
    },
    title: 'Планировки',
    cardSubtitle: 'Нарисуйте план квартиры и посчитайте площади',
    create: 'Новая',
    createFirst: 'Нарисовать планировку',
    defaultName: 'Планировка {{n}}',
    emptyTitle: 'Пока нет планировок',
    emptyText: 'Нарисуйте стены по сетке — замкнутый контур сам станет комнатой с площадью.',
    deleteConfirm: 'Удалить планировку «{{name}}»?',
    notFound: 'Планировка не найдена',
    nameLabel: 'Название планировки',
    saved: 'Сохранено',
    saving: 'Сохранение…',
    saveError: 'Не сохранено',
    undo: 'Отменить',
    redo: 'Повторить',
    zoomIn: 'Приблизить',
    zoomOut: 'Отдалить',
    view3d: '3D',
    view3dOpen: 'Посмотреть в 3D',
    view3dTitle: '3D-вид планировки',
    view3dClose: 'Закрыть 3D',
    view3dLabels: 'Подписи комнат',
    view3dCut: 'Срезать ближние стены',
    wallsNet: 'Стены без проёмов',
    baseboard: 'Плинтус',
    floorFinish: 'Пол',
    wallFinish: 'Стены',
    finishFloor: {
      WOOD: 'Паркет',
      LAMINATE: 'Ламинат',
      TILE: 'Плитка',
      STONE: 'Керамогранит',
      CARPET: 'Ковролин',
      CONCRETE: 'Бетон',
    },
    finishWall: {
      PAINT: 'Краска',
      WALLPAPER: 'Обои',
      TILE: 'Плитка',
      PLASTER: 'Штукатурка',
      PANELS: 'Панели',
    },
    view3dReset: 'Сбросить вид',
    view3dSqm: 'м²',
    view3dEmpty: 'Нарисуйте стены — и здесь появится объёмная модель квартиры',
    view3dHint: 'Тяните — вращать · правой кнопкой или двумя пальцами — сдвигать · колесо или щипок — масштаб',
    fit: 'Показать весь план',
    toolSelect: 'Выбор',
    toolWall: 'Стена',
    done: 'Готово',
    hintEmpty: 'Выберите «Стена» и ставьте точки на сетке',
    emptyReadOnly: 'План пока пустой',
    hintWallStart: 'Зажмите и тяните — отпустите в конце стены. Или ставьте углы касаниями',
    hintWallNext: 'Следующий угол. Замкните контур — появится комната',
    roomDefault: 'Комната {{n}}',
    roomName: 'Название комнаты',
    wall: 'Стена',
    length: 'Длина',
    wallAngle: 'Наклон к горизонту',
    cornerAngle: 'Угол в стыке ({{side}})',
    side: { left: 'слева', right: 'справа', top: 'сверху', bottom: 'снизу' },
    angleHint: 'Наклон поворачивает стену вокруг середины. Угол в стыке меняет стену, соседняя остаётся на месте.',
    thickness: 'Толщина',
    area: 'Площадь',
    perimeter: 'Периметр',
    unitM: 'м',
    unitM2: 'м²',
    roomsCount_one: '{{count}} комната',
    roomsCount_few: '{{count}} комнаты',
    roomsCount_many: '{{count}} комнат',
    roomsCount_other: '{{count}} комнаты',
    bgTitle: 'Фото-подложка',
    bgAdd: 'Добавить фото',
    bgReplace: 'Заменить фото',
    bgOpacity: 'Прозрачность',
    bgLock: 'Закрепить',
    bgUnlock: 'Открепить',
    bgLockedHint: 'Закреплено — перетаскивание и изменение размера отключены',
    bgDeleteConfirm: 'Удалить фото-подложку?',
    chooseTemplate: 'С чего начнём?',
    templateBlank: 'Пустой план',
    templateBlankHint: 'Обвести стены с нуля',
    templateStudio: 'Студия',
    templateOneRoom: 'Однокомнатная',
    templateTwoRoom: 'Двухкомнатная',
    newWallThickness: 'Толщина стены, см',
    thicknessCustom: 'Своя толщина',
    unitCm: 'см',
    unitMm: 'мм',
    lengthUnit: 'Единица длины',
    roomAutoHint: 'Комната определяется стенами: чтобы изменить или убрать её — двигайте или удаляйте стены.',
    toolDoor: 'Дверь',
    toolWindow: 'Окно',
    hintDoor: 'Нажмите на стену, чтобы вставить дверь',
    hintWindow: 'Нажмите на стену, чтобы вставить окно',
    doorWidth: 'Ширина двери, см',
    windowWidth: 'Ширина окна, см',
    widthCustom: 'Своя ширина',
    width: 'Ширина',
    door: 'Дверь',
    window: 'Окно',
    doorFlipHinge: 'Петли на другую сторону',
    doorFlipSide: 'Открывание в другую сторону',
    openingFromCorner: 'От начала стены',
    openingTapWall: 'Нажмите прямо на стену',
    openingWallTooShort: 'Стена слишком короткая для проёма',
    openingOverlap: 'Здесь уже есть проём — выберите другое место',
    cmValue: '{{value}} см',
    roomsList: 'Комнаты',
    roomsEmpty: 'Комнат пока нет — замкните стены, и они появятся здесь.',
    layers: 'Слои',
    layerPlan: 'План',
    layerPlanHint: 'Стены, двери, окна, комнаты',
    layerFurniture: 'Мебель',
    layerEditing: 'Редактируется сейчас',
    layersHide: 'Скрыть слои',
    room: 'Комната',
    walls: 'Стены',
    openings: 'Двери и окна',
    layerShow: 'Показать слой',
    layerHide: 'Скрыть слой',
    layersHint: 'Нажмите на слой, чтобы редактировать его. Остальные видны приглушённо и не мешают.',
    itemsCount_one: '{{count}} предмет',
    itemsCount_few: '{{count}} предмета',
    itemsCount_many: '{{count}} предметов',
    itemsCount_other: '{{count}} предмета',
    addFurniture: 'Добавить',
    hintFurniture: 'Нажмите «Добавить», чтобы расставить мебель',
    rotateLeft: 'Повернуть против часовой',
    rotateRight: 'Повернуть по часовой',
    duplicate: 'Дублировать',
    itemWidth: 'Ширина',
    itemDepth: 'Глубина',
    itemRotation: 'Поворот',
    catalogSearch: 'Поиск по названию',
    layerElectrical: 'Электрика',
    layerPlumbing: 'Сантехника',
    hintElectrical: 'Нажмите «Добавить» — розетки и выключатели прилипают к стене',
    hintPlumbing: 'Нажмите «Добавить» — выводы воды и канализации прилипают к стене',
    catalogFurniture: 'Добавить мебель',
    catalogElectrical: 'Добавить электрику',
    catalogPlumbing: 'Добавить сантехнику',
    itemElevation: 'Высота от пола',
    autoArrange: 'Авто',
    autoReplaceConfirm: 'Расставить слой «{{layer}}» заново? Текущие предметы слоя заменятся — отменить можно кнопкой ↶.',
    autoDone_one: 'Расставлен {{count}} предмет — поправьте вручную или отмените ↶',
    autoDone_few: 'Расставлено {{count}} предмета — поправьте вручную или отмените ↶',
    autoDone_many: 'Расставлено {{count}} предметов — поправьте вручную или отмените ↶',
    autoDone_other: 'Расставлено {{count}} предмета — поправьте вручную или отмените ↶',
    autoEmptyFurniture: 'Нечего расставить: замкните стены в комнаты и назовите их (Спальня, Кухня…)',
    autoEmptyElectrical: 'Нечего расставить: сначала нарисуйте комнаты и двери',
    autoEmptyPlumbing: 'Сначала поставьте сантехнику (ванна, раковина, унитаз…) в слое «Мебель»',
    toolPassage: 'Проход',
    toolBalcony: 'Балкон',
    toolDivider: 'Граница зоны',
    hintDividerStart: 'Проведите границу между зонами без стены — например, коридор и кухня-гостиная',
    traceHint: 'Стены, двери и окна найдёт на фото чертежа, масштаб AI прочитает по подписанным размерам. Лучше всего — чёткий план; наклонные стены не находятся.',
    traceFound: 'Найдено стен: {{count}}',
    traceLongest: 'Длина самой длинной стены',
    traceScaleHint: 'На фото нет единиц измерения: введите настоящую длину самой длинной стены — по ней выставится масштаб.',
    traceApply: 'Нарисовать стены',
    traceReplaceConfirm: 'Стены в плане уже есть — заменить их найденными?',
    aiCheckBtn: 'Нарисовать с AI',
    aiCheckRunning: 'AI рисует…',
    aiCheckFailed: 'Не удалось распознать фото',
    aiScaleUnavailable: 'AI недоступен — масштаб задайте вручную',
    aiScaleHint: 'Масштаб взят по подписанному на плане размеру — проверьте длину самой длинной стены и поправьте, если нужно.',
    aiCheckTitle: 'Заключение AI',
    aiCheckWalls: 'Стены видны',
    aiCheckDimensions: 'Размеры подписаны',
    aiCheckThickness: 'Толщина стен понятна',
    ceilingHeight: 'Высота потолка',
    ceilingApplyAll: 'Применить ко всем',
    wallsArea: 'Площадь стен',
    volume: 'Объём',
    unitM3: 'м³',
    toolRuler: 'Линейка',
    hintRulerItem: 'Нажмите на предмет — покажу расстояния от него до стен и мебели',
    hintRulerA: 'Нажмите первую точку: угол стены или край предмета',
    hintRulerB: 'Нажмите вторую точку',
    rulerModeItem: 'От предмета',
    rulerModePoints: 'Две точки',
    hintPassage: 'Нажмите на стену, чтобы сделать проход без двери',
    hintBalcony: 'Нажмите на наружную стену — балкон встанет с её внешней стороны',
    passageWidth: 'Ширина прохода, см',
    passage: 'Проход',
    balconyWidth: 'Ширина балкона',
    balconyDepth: 'Глубина балкона',
    balconyDefault: 'Балкон',
    balconyDefaultN: 'Балкон {{n}}',
    balconyShort: 'балкон',
    balconyTapWall: 'Нажмите прямо на наружную стену',
    balconyInnerWall: 'Балкон ставится только на наружную стену',
    balconyNoSpace: 'Здесь уже занято — выберите другое место',
    outdoorBadge: 'не входит в общую',
    outdoorHint: 'Балкон считается отдельно и в общую площадь не входит. Он держится на ограждении: уберёте его — получится обычная комната.',
    railing: 'Ограждение балкона',
    railingHint: 'Парапет вместо стены: замкнутый контур с ним — балкон, он не входит в общую площадь',
    divider: 'Граница зоны',
    dividerToggle: 'Без стены — граница зоны',
    dividerHint: 'Делит открытое пространство на комнаты: толщины нет, площадь не уменьшает, в 3D не видна',
  },
  catalog: {
    category: {
      living: 'Гостиная',
      bedroom: 'Спальня',
      kitchen: 'Кухня и столовая',
      bathroom: 'Санузел',
      other: 'Прочее',
      hallway: 'Прихожая',
      sockets: 'Розетки',
      switches: 'Выключатели',
      lighting: 'Освещение',
      equipment: 'Оборудование',
      water: 'Водоснабжение',
      sewerage: 'Канализация',
    },
    sofa3: 'Диван 3-местный',
    sofa2: 'Диван 2-местный',
    cornerSofa: 'Угловой диван',
    armchair: 'Кресло',
    coffeeTable: 'Журнальный столик',
    tvStand: 'ТВ-тумба',
    shelf: 'Стеллаж',
    plant: 'Растение',
    doubleBed: 'Кровать двуспальная',
    singleBed: 'Кровать односпальная',
    nightstand: 'Тумбочка',
    wardrobe: 'Шкаф',
    dresser: 'Комод',
    kitchenCounter: 'Кухонный гарнитур',
    stove: 'Плита',
    fridge: 'Холодильник',
    kitchenSink: 'Мойка',
    diningTable: 'Обеденный стол',
    roundTable: 'Круглый стол',
    chair: 'Стул',
    bathtub: 'Ванна',
    shower: 'Душевая',
    toilet: 'Унитаз',
    washbasin: 'Раковина',
    washer: 'Стиральная машина',
    desk: 'Рабочий стол',
    officeChair: 'Офисное кресло',
    pouf: 'Пуф',
    sideboard: 'Комод-буфет',
    bookcase: 'Книжный шкаф',
    rug: 'Ковёр',
    floorLamp: 'Торшер',
    kingBed: 'Кровать 180×200',
    kidsBed: 'Детская кровать',
    crib: 'Детская кроватка',
    vanityTable: 'Туалетный столик',
    slidingWardrobe: 'Шкаф-купе',
    dishwasher: 'Посудомоечная машина',
    oven: 'Духовой шкаф',
    kitchenIsland: 'Кухонный остров',
    cornerKitchen: 'Угловой гарнитур',
    barStool: 'Барный стул',
    smallBathtub: 'Ванна 150 см',
    showerTray: 'Душевой поддон',
    bidet: 'Биде',
    doubleSink: 'Двойная раковина',
    dryer: 'Сушильная машина',
    waterHeater: 'Водонагреватель',
    towelRail: 'Полотенцесушитель',
    shoeCabinet: 'Обувница',
    hallWardrobe: 'Шкаф в прихожую',
    bench: 'Банкетка',
    coatRack: 'Открытая вешалка',
    radiator: 'Радиатор',
    piano: 'Пианино',
    treadmill: 'Беговая дорожка',
    socket: 'Розетка',
    socketDouble: 'Двойная розетка',
    socketKitchen: 'Розетка над столешницей',
    socketWaterproof: 'Влагозащищённая розетка',
    socketPower: 'Силовая розетка (плита)',
    tvSocket: 'ТВ-розетка',
    lanSocket: 'Интернет-розетка',
    switch: 'Выключатель',
    switchDouble: 'Двухклавишный выключатель',
    switchPass: 'Проходной выключатель',
    dimmer: 'Диммер',
    ceilingLight: 'Потолочный светильник',
    chandelier: 'Люстра',
    spotLight: 'Точечный светильник',
    sconce: 'Бра',
    ledStrip: 'LED-лента',
    electricalPanel: 'Электрощит',
    junctionBox: 'Распаечная коробка',
    thermostat: 'Терморегулятор',
    floorHeating: 'Тёплый пол',
    airConditioner: 'Кондиционер',
    exhaustFan: 'Вытяжной вентилятор',
    intercom: 'Домофон',
    waterCold: 'Холодная вода',
    waterHot: 'Горячая вода',
    waterRiser: 'Стояк водоснабжения',
    valve: 'Кран',
    waterMeter: 'Счётчик воды',
    sewerOutlet: 'Вывод канализации',
    sewerRiser: 'Стояк канализации',
    floorDrain: 'Трап',
    manifold: 'Коллектор',
    waterFilter: 'Фильтр воды',
    heatingBoiler: 'Котёл',
  },
  analytics: {
    title: 'Аналитика',
    cardSubtitle: 'Графики и инсайты по расходам',
    accountingDays: '{{count}} дн. учёта',
    empty: 'Пока нет оплаченных расходов. Добавьте расходы — и здесь появятся графики и метрики.',
    total: 'Всего',
    count: 'Расходов',
    average: 'Средний чек',
    median: 'Медиана',
    perDay: 'В день',
    days: 'Дней учёта',
    maxExpense: 'Самая дорогая покупка',
    spendingOverTime: 'Динамика трат',
    cumulative: 'Накопительно',
    byCategory: 'По категориям',
    operations: '{{count}} оп.',
    peakDay: 'Самый дорогой день',
    peakWeek: 'Самая дорогая неделя',
    topExpenses: 'Топ расходов',
    uncategorized: 'Без категории',
    otherCategories: 'Остальные категории',
    note: 'Учитываются только оплаченные расходы, суммы приведены к валюте проекта.',
    updatedAt: 'обновлено {{date}}',
  },
  yandex: {
    title: 'Авторизация через Яндекс',
    redirecting: 'Перенаправляем в etap...',
    error: 'Ошибка авторизации',
    cancelled: 'Авторизация отменена',
    retry: 'Попробовать снова',
  },
  editor: {
    bold: 'Жирный',
    italic: 'Курсив',
    underline: 'Подчёркнутый',
    bulletList: 'Маркированный список',
    orderedList: 'Нумерованный список',
    taskList: 'Чек-лист',
    link: 'Ссылка',
    unlink: 'Удалить ссылку',
    h1: 'Заголовок 1',
    h2: 'Заголовок 2',
    h3: 'Заголовок 3',
    placeholder: 'Начните писать...',
  },
} as const;
